module.exports = __webpack_public_path__ + "static/bg5-707a719176322292dafe7b4942bb41df.svg";